import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Register',
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        reset() {
            localStorage.clear();//clear all
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        
        login(){
            this.disable_btn = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            }

            let navi = this.$router;
            if(credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name); 
                        localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                        localStorage.setItem("sp_token_key", data.user_token_key); 
                        navi.push('account');
                    }else{
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn = false;
                    }
                }).catch((err) => {
                  //  console.log(err)
                    toastr.warning("invalid login credentials", 'Warning!'); 
                    this.disable_btn = false;
                })
                    
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        }
    },
    created: function(){
       this.reset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Login/script.js